import QuestionModel from "../../maths/QuestionModel";
import QuestionViewVerbal from "./QuestionViewVerbal";
import converter from "../../../libs/number-to-words";

export default class QuestionViewVerbalCompose extends QuestionViewVerbal {
    constructor(question) {
        super(question);
        this._inputField.visible = (question.part !== 0);
    }

    getHeaderText() {
        const data = P3.assets.json("templates");
        const split = this._question.template.split("/");
        let templates = data.templates[split[0]][split[1]];

        if (templates && templates.length > 0) {
            templates = templates.slice().filter(x => this.filterTemplate(x));
        } else return "ERROR: NO TEMPLATE FOUND";

        this._template = P3.utils.selectRandom(templates);

        let text = this._template ? this._template.text : "";

        const baseArray = ["ones", "tens", "hundreds", "thousands"];

        const values = this.generateValues(this._template.text, /\[VALUE([0-9])?]/g);
        for (const i in values) {
            if (values.hasOwnProperty(i)) {
                if (i === "[VALUE0]") {
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), values[i]);
                } else {
                    //grab the index from the string
                    const baseIndex = parseInt(i.substr(6, 6)) - 1;
                    text = text.replace(new RegExp(P3.utils.escape(i), "g"), baseArray[baseIndex]);
                }
            }
        }

        const length = this.generateValues(this._template.text, /\[LENGTH]/g);
        for (const i in length) {
            if (length.hasOwnProperty(i)) {
                text = text.replace(new RegExp(P3.utils.escape(i), "g"), Math.random() < 0.5 ? this._question.length : converter.toWords(this._question.length));
            }
        }

        const match = text.match(/\. [a-z]/g);
        if (match) {
            for (let i = 0; i < match.length; ++i) {
                const s = match[i];
                text = text.replace(new RegExp(P3.utils.escape(s), "g"), s.toUpperCase());
            }
        }

        return text;
    }

    generateValues(text, regex) {
        const values = {};
        let result = text.match(regex);
        if (result) {
            for (let i = 0; i < result.length; ++i) {
                const t = result[i];
                const match = t.match(/[0-9]/);
                const index = match ? parseInt(match[0]) : 0;
                const value = this._question.values[index].value;
                if (!values[t]) {
                    values[t] = value;
                }
            }
        }
        return values;
    }

    setAnswer(value) {
        this._inputValue = value;

        if (!Array.isArray(value)) {
            if (value) {
                const str = value.toString();
                this._inputField.label.text = str;
                this._inputField.label.style.fontSize = str.length < 5 ? 40 : 20;
            } else {
                this._inputField.label.text = "?";
                this._inputField.label.style.fontSize = 40;
            }
        }
    }

    isCorrect() {
        if (this._inputValue.length && this._inputValue.length > 0) {
            let sum = 0;
            for (let i = 0; i < this._inputValue.length; i++) {
                sum += this._inputValue[i].value;
            }
            return sum === this._question.answer.value;
        } else {
            return this._inputValue.value === this._question.answer.value;
        }
    }

    filterTemplate(x) {
        return x.part === this._question.part;
    }
}